import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PropuestaOriginal from './pages/PropuestaOriginal';
import NuevaPropuesta from './pages/NuevaPropuesta';
import DemoLogin from './pages/DemoLogin';
import DemoDashboard from './pages/DemoDashboard';
import DemoNuevaPublicacion from './pages/DemoNuevaPublicacion';
import DemoPublicaciones from './pages/DemoPublicaciones';
import DemoPublicacionDetalle from './pages/DemoPublicacionDetalle';
import DemoRevendedores from './pages/DemoRevendedores';
import DemoReportes from './pages/DemoReportes';
import './App.css';

// Componente de protección de rutas para la demo
function ProtectedDemoRoute({ children }) {
  const isAuthenticated = localStorage.getItem('demo_authenticated') === '1';
  return isAuthenticated ? children : <Navigate to="/propuesta/demo" replace />;
}

function App() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      {/* Propuesta Original */}
      <Route path="/" element={<PropuestaOriginal />} />
      
      {/* Nueva Propuesta */}
      <Route path="/propuesta" element={<NuevaPropuesta />} />
      
      {/* Demo - Login */}
      <Route path="/propuesta/demo" element={<DemoLogin />} />
      
      {/* Demo - Rutas Protegidas */}
      <Route 
        path="/propuesta/demo/dashboard" 
        element={
          <ProtectedDemoRoute>
            <DemoDashboard />
          </ProtectedDemoRoute>
        } 
      />
      <Route 
        path="/propuesta/demo/nueva" 
        element={
          <ProtectedDemoRoute>
            <DemoNuevaPublicacion />
          </ProtectedDemoRoute>
        } 
      />
      <Route 
        path="/propuesta/demo/publicaciones" 
        element={
          <ProtectedDemoRoute>
            <DemoPublicaciones />
          </ProtectedDemoRoute>
        } 
      />
      <Route 
        path="/propuesta/demo/publicacion/:id" 
        element={
          <ProtectedDemoRoute>
            <DemoPublicacionDetalle />
          </ProtectedDemoRoute>
        } 
      />
      <Route
        path="/propuesta/demo/revendedores"
        element={
          <ProtectedDemoRoute>
            <DemoRevendedores />
          </ProtectedDemoRoute>
        }
      />
      <Route
        path="/propuesta/demo/reportes"
        element={
          <ProtectedDemoRoute>
            <DemoReportes />
          </ProtectedDemoRoute>
        }
      />
      
      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
